var render, staticRenderFns
import script from "./CustomSide.vue?vue&type=script&lang=tsx"
export * from "./CustomSide.vue?vue&type=script&lang=tsx"
import style0 from "./CustomSide.vue?vue&type=style&index=0&id=22aac030&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aac030",
  null
  
)

export default component.exports